module.exports = __webpack_public_path__ + "img/Julibee_Logo.5d2aa62d.png";